export default __webpack_public_path__ + "static/media/home_loading.ff291559.gif";